import React, { Component } from 'react';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './defaultHeader.scss';

/*-- Import required components --*/
import CartBox from './CartBox';
import ProductSearch from '../productSearch/ProductSearch';
import NexusIcon from '../../assets/img/icons/Nexus_icon.png';
import PremiumIcon from '../../assets/img/icons/Premium_icon.png';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import { UserGuider } from './../common';
import NotificationStripe from '../notificationHub/NotificationStripe';
import UserGuiderSuccess from '../common/userGuider/UserGuiderSuccess';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';
import { showPreferenceModal } from '../../redux/actions/preferenceModalActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        shoppingPreference: state.shoppingPreference,
        userDetails: state.userDetails
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showMessageBox,
    resetMessageBox,
    showPreferenceModal
};

class DefaultHeaderDesktop extends Component {
    constructor(props) {
        super(props);
        this.RefUserIcon = React.createRef();
        this.RefChangeStore = React.createRef();
    }

    launchChanger() {
        let body = {
            show: true
        }
        this.props.showPreferenceModal(body);
    }

    showNexusLogo() {
        let showNexusLogo = false;
        if (this.props.userDetails.isNexus) {
            if (this.props.userDetails.isPremiumCustomer) {
                showNexusLogo = false;
            } else {
                showNexusLogo = true;
            }
        } else {
            showNexusLogo = false;
        }

        return showNexusLogo;
    }

    render() {
        return (
            <div className="default-header-container">
                <UserGuider
                    name='UserIcon'
                    target={this.RefUserIcon}
                    placement='bottom'
                    content='We seem to have an incomplete record for you. Please update your account now.'
                />
                {/* <UserGuiderSuccess
                    isMobile={false}
                    name='ChangeStore'
                    target={this.RefChangeStore}
                    placement='bottom'
                    expirytime={200000}
                    content='Click here to change the delivery location'
                /> */}
                <NotificationStripe />
                <div className="default-header-top-bar">
                    <Col xs="12" md={{ span: 10, offset: 1 }} >
                        <Row>
                            {!this.props.userDetails.isGuest ?
                                <Col lg='2' md='3' onClick={() => { window.location.href = ("/welcome/TrackOrder") }} className="upper-item-container my-account-redirect">
                                    <i className="fas fa-sign-out-alt" />
                                    Track My Order
                                </Col> :
                                null
                            }
                            <Col>
                                <Row className="upper-item-container">
                                    {/* <Col md="auto" xs="12" className="nav-item nav-item-divider my-account-redirect" onClick={(e) => { this.props.userDetails.isGuest === false ? window.location.href ="/myaccount") : e.preventDefault() }}> */}
                                    <Col md="auto" xs="12" className="nav-item nav-item-divider my-account-redirect" onClick={(e) => { (this.props.userDetails.isGuest === false) && (window.location.href = "/myaccount") }}>
                                        {!this.props.userDetails.isGuest
                                            ?
                                            <i className="fas fa-user">
                                                <img
                                                    src={NexusIcon}
                                                    title="Nexus Member"
                                                    alt="nexus_icon"
                                                    style={{ display: this.showNexusLogo() ? "" : "none", width: "20px", height: "19px" }}>
                                                </img>
                                                <img
                                                    src={PremiumIcon}
                                                    title="Long standing Nexus Member"
                                                    alt="premium_icon"
                                                    style={{ display: this.props.userDetails.isPremiumCustomer ? "" : "none", width: "26px", height: "22px" }}>
                                                </img>
                                            </i>
                                            :
                                            <div onClick={() => { window.location.href = ("/welcome/TrackOrder") }} className="">
                                                <i className="fas fa-sign-out-alt" />
                                                Track My Order
                                            </div>
                                        }
                                        {!this.props.userDetails.isDetailsCompleted && !this.props.userDetails.isGuest
                                            ? <i className="fas fa-exclamation" ref={this.RefUserIcon} style={{ color: 'red', fontSize: '15px' }} title="We seem to have an incomplete record for you. Please update your account now."></i> : null}
                                        {this.props.userDetails.isGuest ? '' : 'Welcome, ' + this.props.userDetails.customerName}
                                    </Col>
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 200, hide: 400 }}
                                        overlay={
                                            <Tooltip>
                                                Click here to change the delivery location
                                            </Tooltip>
                                        }
                                    >
                                        <Col md="auto" xs="12" className="nav-item nav-item-divider logoutClass" onClick={() => { this.launchChanger() }}>
                                            <i className="fas fa-map-marker-alt" />
                                            Store Location
                                            <div className="upper-nav-item-dropdown-container my-account-redirect" ref={this.RefChangeStore}>{this.props.shoppingPreference.outletName}</div>
                                        </Col>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 200, hide: 300 }}
                                        overlay={
                                            <Tooltip>
                                                Click here to change the shipping method
                                            </Tooltip>
                                        }
                                    ><Col md="auto" xs="12" className="nav-item nav-item-divider logoutClass" onClick={() => { this.launchChanger() }}>
                                            <i className="fas fa-truck" />
                                            Shipping Method
                                            <div className="upper-nav-item-dropdown-container my-account-redirect">{this.props.shoppingPreference.shoppingMethod}</div>
                                        </Col>
                                    </OverlayTrigger>
                                    {
                                        this.props.userDetails.isGuest ?
                                            <Col md="auto" xs="12" className="nav-item logoutClass" onClick={this.props.login}>
                                                <i className="fas fa-sign-out-alt" />
                                                Signup | Login
                                            </Col>
                                            :
                                            <Col md="auto" xs="12" className="nav-item logoutClass" onClick={this.props.logout}>
                                                <i className="fas fa-sign-out-alt" />
                                                Log Out
                                            </Col>
                                    }

                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div className="default-header-navbar">
                    <Col md={{ span: 10, offset: 1 }} className='row'>
                        {/* logo */}
                        <Col lg='2' md='3'>
                            <a href={`${window.location.origin}/`}>
                                <img src={KeellsLogo} className="img-fluid"></img>
                            </a>
                        </Col>

                        <Col lg='10' md='9' className='pr-0'>
                            <div className="align-items-center navbar-items-container">
                                <div className='nav-container'>
                                    <div className="nav-item-navbar nav-item-highlighted" onClick={() => { window.location.href = "/"; }}>
                                        Home
                                    </div>
                                    {/* <div className="nav-item-navbar" onClick={() => { window.location.href = "/showcaseint/items/hamper"; }}>
                                        Hampers
                                    </div> */}
                                    <div className="nav-item-navbar" onClick={() => { window.location.href = "/showcaseint/items/keells_products"; }}>
                                        Keells Products
                                    </div>
                                    <div className="nav-item-navbar" onClick={() => { window.location.href = "/showcaseint/items/keells_exclusives"; }}>
                                        Keells Exclusives
                                    </div>
                                    <div className="nav-item-navbar" onClick={() => { window.location.href = "/keells-promotions"; }}>
                                        All Promotions
                                    </div>
                                    {/* <div className="nav-item-navbar" onClick={() => { window.location.href = "/product/6"; }}>
                                        Catalogues & Deals
                                    </div> */}
                                    {/* <div className="nav-item-navbar" onClick={() => { window.location.href = "/showcaseint/christmas_2021?utm_source=internal_website&utm_medium=site_header&utm_campaign=christmas_2021"; }}>
                                        Seasonal Specials
                                    </div> */}
                                    {/* <div className="nav-item-navbar" onClick={() => { window.location.href = "/StoreLocator"; }}>
                                                Stores
                                            </div> */}

                                    {/* <div className="nav-item-navbar" onClick={() => { window.location.href = "/contactUs"; }}>
                                        Contact us
                                    </div> */}
                                    <div className="nav-item-navbar nav-item-highlighted" onClick={() => { window.location.href = "/utility-bill-payment"; }}>
                                        <i className="fas fa-receipt"></i>
                                        Utility Bill Payment
                                    </div>
                                    <div className="nav-item-navbar nav-item-highlighted" onClick={() => { window.location.href = "/keells-community"; }}>
                                        <i className="fas fa-heart"></i>
                                        Community
                                    </div>
                                    {/* <div className="nav-item-navbar nav-item-highlighted" >

                                    </div> */}
                                    <div className="nav-item-navbar nav-item-highlighted" >

                                    </div>
                                    <CartBox />
                                </div>
                            </div>
                        </Col>
                    </Col>
                    {/* product search */}
                    <Col md={{ span: 10, offset: 1 }}>
                        <ProductSearch />
                    </Col>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeaderDesktop);
